<div class="register-container">
    <div class="left-container">
        <ui-steps-progress [steps]="steps" [stepNumber]="stepNumber"
            [typeOfRegistration]="typeOfRegistration"
            (exitOnboarding)="logoutOnboarding()"></ui-steps-progress>
    </div>
    <div class="right-container">
        <div class="container">

            <div class="step-container">
                <div class="step-content !max-w-7xl !mx-auto">
                    <!--registrazione atleti-->
                    <ng-container *ngIf="typeOfRegistration === 'athlete' ">
                        <app-register-user (step)="updateStep($event)"></app-register-user>
                    </ng-container>

                    <!--registrazione Agenti-->
                    <ng-container *ngIf="typeOfRegistration === 'agent'">
                        <app-register-agent (step)="updateStep($event)"
                            (listOfSteps)="updateSteps($event)"></app-register-agent>
                    </ng-container>

                    <!--registrazione società-->
                    <ng-container *ngIf="typeOfRegistration === 'company'">
                        <app-register-company [idService]="idServiceFromQuery" (step)="updateStep($event)"
                            (listOfSteps)="updateSteps($event)"></app-register-company>
                    </ng-container>

                    <!--registrazione Staff-->
                    <ng-container *ngIf="typeOfRegistration === 'staff'">
                        <app-register-staff (step)="updateStep($event)"
                            (listOfSteps)="updateSteps($event)"></app-register-staff>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <button
        *ngIf="typeOfRegistration === 'company'"
        type="button"
        class="onboarding-mobile-logout"
        (click)="logoutOnboarding()"
    >
        <i class="bi bi-box-arrow-left" aria-hidden="true"></i>
        <span>Esci</span>
    </button>
</div>
